module.exports = __webpack_public_path__ + "media/images/flower_gold-2d9125ba9f1b6a0872a8e86ea5a82a19.svg";